import React from 'react';

import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from '../src/components/App';
import { store } from '../src/store';
import { IChatInit, IUserData } from '../src/types/chat';
import { setChatOpenState } from '../src/store/actions/chat';
import { updateUser } from '../src/store/slices/user';

let rootApp: Root | null = null;

export const initChat = (data: IChatInit = {}) => {
  const containerId = data.containerId || 'chat-root';

  let container = document.getElementById(containerId);

  if (!container) {
    container = document.createElement('div');
    container.id = containerId;
    container.setAttribute('role', 'application');
    document.body.appendChild(container);
  }

  const createdContainer = document.getElementById(containerId);

  if (createdContainer) {
    rootApp = createRoot(createdContainer);

    rootApp.render(
      <Provider store={store}>
        <App chatInitData={data} />
      </Provider>,
    );
  }
};

export const updateChat = (data: IChatInit) => {
  unmountChat();
  initChat(data);
};

export const unmountChat = () => {
  if (rootApp) {
    rootApp.unmount();
    rootApp = null;
  }
};

export const showChat = () => {
  store.dispatch(setChatOpenState(true));
};

export const hideChat = () => {
  store.dispatch(setChatOpenState(false));
};

export const updateUserData = (data: IUserData) => {
  store.dispatch(updateUser(data));
};

export const isChatActive = () => {
  return !!store.getState().chat?.id;
};
